import ComparisonMetricsTrendCo from '@/pages/dashboard/components/MetricsTrendCo/ComparisonMetricsTrendCo';
import PcConsoleDateComparisonFilter from '@/pages/dashboard/filterPageComponents/comparison/pcEventComparisonFilter';
import MobileEventComparisonFilter from '@/pages/dashboard/filterPageComponents/comparison/mobileEventComparisonFilter';
import NightingaleEventComparisonFilter from '@/pages/dashboard/filterPageComponents/comparison/nightingaleEventComparisonFilter';

import ComparisonTableCo from '@/pages/dashboard/pages/comparison/components/ComparisonTableCo';
import EventAnalysisTrendCo from '@/pages/dashboard/components/MetricsTrendCo/EventAnalysisTrendCo';
import EventFilter from '@/pages/dashboard/filterPageComponents/event/eventFilter';
import MobileEventFilter from '@/pages/dashboard/filterPageComponents/event/mobileEventFilter';
import CountryComparisonFilter from '@/pages/dashboard/filterPageComponents/comparison/CountryComparisonFilter';
import NightingaleEventFilter from '@/pages/dashboard/filterPageComponents/event/nightingaleEventFilter';
import EventTableCo from '@/pages/dashboard/pages/eventAnalysis/components/EventTableCo';
import DateFilter from '@/pages/dashboard/filterPageComponents/comparison/dateComparisonFilterNew';
import SegmentMoreCo from '@/pages/dashboard/pages/comparison/dateComparison/component/SegmentMoreCo';
import DateComparisonMetricsTrend from '@/pages/dashboard/pages/comparison/dateComparison/component/DateComparisonMetricsTrend';
import NightingaleRetentionFilter from '@/pages/dashboard/filterPageComponents/comparison/nightingaleRetentionFilter';
import RetentionChart from '@/pages/dashboard/pages/comparison/dateComparison/component/RetentionChart';
import dateComparisonTrendService from '@/pages/dashboard/pages/comparison/dateComparison/dateComparisonTrendService';
import NightingaleDateComparisonFilter from '@/pages/dashboard/filterPageComponents/comparison/nightingaleDateComparisonFilter';
import CountryComparisonService from '@/pages/dashboard/pages/comparison/countryComparison/_components/CountryComparisonService';
import SegmentTabsCo from '@/pages/dashboard/components/SegmentMoreCo';
import CountryComparisonChart from '@/pages/dashboard/pages/comparison/countryComparison/_components/CountryComparisonChart';

export default {
  ComparisonMetricsTrendCo,
  PcConsoleDateComparisonFilter,
  MobileEventComparisonFilter,
  NightingaleEventComparisonFilter,
  ComparisonTableCo,
  EventAnalysisTrendCo,
  EventFilter,
  MobileEventFilter,
  NightingaleEventFilter,
  EventTableCo,
  DateFilter,
  dateComparisonTrendService,
  SegmentMoreCo,
  DateComparisonMetricsTrend,
  NightingaleDateComparisonFilter,
  NightingaleRetentionFilter,
  RetentionChart,
  CountryComparisonFilter,
  CountryComparisonService,
  SegmentTabsCo,
  CountryComparisonChart,
}